<template>
  <div class="Profile__Page">
    <div class="Profile__Page__Menu">
      <h1>אדמיניסטרציה</h1>
      <b-menu>
        <b-menu-list>
          <b-menu-item label="פרופילים" tag="router-link" to="/admin/profiles"></b-menu-item>
          <b-menu-item label="ניהול דוחות" tag="router-link" to="/admin/search/reports"></b-menu-item>
          <b-menu-item label="דוחות לא מנוהלים" tag="router-link" to="/admin/search/unmanagedreports"></b-menu-item>
          <b-menu-item label="ניהול רכבים" tag="router-link" to="/admin/search/vehicles"></b-menu-item>
          <b-menu-item label="ניהול עיריות" tag="router-link" to="/admin/search/municipalities"></b-menu-item>
          <b-menu-item>
            <template #label="props">
              ייבוא
              <b-icon class="is-pulled-left" :icon="props.expanded ? 'menu-up' : 'menu-down'"></b-icon>
            </template>
            <b-menu-item label="דוחות" tag="router-link" to="/admin/import/reports"></b-menu-item>
            <b-menu-item label="נהגים" tag="router-link" to="/admin/import/drivers"></b-menu-item>
            <b-menu-item label="רכבים" tag="router-link" to="/admin/import/vehicles"></b-menu-item>
            <b-menu-item label="רכבים עם בעלות בלבד" tag="router-link" to="/admin/import/vehicles/owned"></b-menu-item>
            <b-menu-item label="רכבים גרסה 2" tag="router-link" to="/admin/import/newvehicles"></b-menu-item>
            <b-menu-item label="רכבים גרסה 3" tag="router-link" to="/admin/import/newvehiclesv3"></b-menu-item>
            <b-menu-item label="משטרה" tag="router-link" to="/admin/import/police"></b-menu-item>
            <b-menu-item label="היסטוריית יבוא" tag="router-link" to="/admin/batchReports"></b-menu-item>
            <b-menu-item label="מרכז לגביית קנסות" tag="router-link" to="/admin/import/finecenter"></b-menu-item>
          </b-menu-item>
          <!-- <b-menu-item>
            <template #label="props">
              ניתוח פעילות
              <b-icon class="is-pulled-left" :icon="props.expanded ? 'menu-up' : 'menu-down'"></b-icon>
            </template>
            <b-menu-item label="דו''ח שנתי" tag="router-link" to="/admin/analytics/yearly"></b-menu-item>
          </b-menu-item> -->
          <b-menu-item>
            <template #label="props">
              כלים
              <b-icon class="is-pulled-left" :icon="props.expanded ? 'menu-up' : 'menu-down'"></b-icon>
            </template>
            <b-menu-item label="יצירת קובץ לייבוא" tag="router-link" to="/admin/import/create"></b-menu-item>
            <b-menu-item label="סריקת נתוני מיקום" tag="router-link" to="/admin/import/locationdatascan"></b-menu-item>
            <b-menu-item label="סריקת נתוני דוחות" tag="router-link" to="/admin/crawlReports"></b-menu-item>
            <b-menu-item label="מחולל התראות" tag="router-link" to="/admin/import/generatealerts"></b-menu-item>
          </b-menu-item>
          <b-menu-item tag="router-link" to="/admin/transfer-bots">
            <template #label>
              בוטי הסבות
              <b-icon
                v-if="botsHaveAlert"
                size="is-small"
                type="is-danger"
                class="is-pulled-left"
                icon="alert-circle"
              ></b-icon>
              <b-icon
                v-else-if="botsReady"
                size="is-small"
                type="is-success"
                class="is-pulled-left"
                icon="circle"
              ></b-icon>
            </template>
          </b-menu-item>
          <b-button class="terms-button" @click.prevent="openTerms">קובץ נהלים בטר וואי</b-button>
        </b-menu-list>
      </b-menu>
    </div>
    <div class="Profile__Page__Content">
      <router-view v-if="ready" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import store from '../store';

export default {
  name: "Profile",

  async created() {
    this.ready = true;
    this.startBotsPolling();
    if (this.profileId && this.$route.name !== 'addReport') {
      store.commit("auth/setProfileId", null);
      window.location.href = this.$router.resolve({ name: "admin" }).href;
    }
  },
  beforeDestroy() {
    this.stopBotsPolling();
  },
  computed: {
    ...mapGetters('transferBots', { botsHaveAlert: 'hasAlert' }),
    ...mapState('transferBots', { botsLastPollAt: 'lastPollAt' }),
    botsReady() {
      return this.botsLastPollAt !== null;
    },
    isAdmin() {
      return this.$store.state.auth?.user?.claims?.isAdmin === "True";
    },
    profileId() {
      return this.$store.state.auth.profileId;
    },
  },
  data() {
    return {
      ready: false,
    };
  },
  methods: {
    ...mapActions('transferBots', {
      startBotsPolling: 'startPolling',
      stopBotsPolling: 'stopPolling',
    }),
    openTerms() {
      window.open('https://docs.google.com/document/d/1G5ew2haT7LTtrP85ea39wdU5Q0cI4cTmBejbLFCPm3k/edit?tab=t.gyjdjvchlnl5', '_blank');
    }
  },
};
</script>
<style lang="scss" scoped>
.Profile__Page {
  display: flex;

  .Profile__Page__Menu {
    flex-basis: 300px;
    background-color: #f5f8fa;
    min-height: calc(100vh - 50px);
    padding: 20px;
    display: flex;
    flex-direction: column;

    ::v-deep .menu {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    ::v-deep .menu-list {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .terms-button {
      width: 100%;
      margin-top: auto;
    }

    h1 {
      font-size: 25px;
      padding: 5px 10px;
    }

    ::v-deep a {
      color: inherit;
      padding: 10px 10px;
      font-size: 16px;
      width: 100%;
      display: block;
      border-radius: 3px;

      &.router-link-exact-active {
        background-color: #eaf0f6;
        font-weight: 500;
      }

      &:hover {
        background-color: #eaf0f6;
      }
    }
  }

  .Profile__Page__Content {
    flex: 1;
    border-right: 1px solid #c0c0c09e;
    overflow-x: auto;
    width: calc(100% - 300px);
  }
}

::v-deep {
  .menu-list a.is-active {
    background: inherit;
  }
}

</style>
